/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Legalguardian21Inputs */

const de__field_legalguardian21 = /** @type {(inputs: _Field_Legalguardian21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zweite Erziehungsberechtigte Person`)
};

/**

* @param {_Field_Legalguardian21Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_legalguardian21 = /** @type {((inputs?: _Field_Legalguardian21Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Legalguardian21Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_legalguardian21(inputs)
});
export { _field_legalguardian21 as "_field_legalGuardian2" }